export const CONTEXT_TYPES = {
  SET_CONFIG: 'CONTEXT_SET_CONFIG',
  SET_ERROR: 'CONTEXT_SET_ERROR',
  RESET_ERRORS: 'CONTEXT_RESET_ERRORS',
  SET_CHECK_USER_DEVICE: 'CONTEXT_SET_CHECK_USER_DEVICE',
  SET_USER_DEVICE_EXISTS: 'CONTEXT_SET_USER_DEVICE_EXISTS',
  TRIGGER_USER_MANUAL_REGISTER: 'CONTEXT_TRIGGER_USER_MANUAL_REGISTER',
  SET_DID_INITIAL_AUTH: 'CONTEXT_SET_DID_INITIAL_AUTH',
  SET_DID_AUTH_TOKENS: 'CONTEXT_SET_DID_AUTH_TOKENS',
  SET_USER_WIZARD_DATA: 'CONTEXT_SET_USER_WIZARD_DATA',
  SET_IDENTIFY_WIZARD_STEP: 'CONTEXT_SET_IDENTIFY_WIZARD_STEP',
  SET_IDENTIFY_PROVIDER: 'CONTEXT_SET_IDENTIFY_PROVIDER',
  SET_WIZARD_FIELDS: 'CONTEXT_SET_WIZARD_FIELDS',
  SET_WAITING_FOR_IDENTIFY_PROVIDER: 'CONTEXT_SET_WAITING_FOR_IDENTIFY_PROVIDER',
  SET_WIZARD_PROVIDER_OBJECT: 'CONTEXT_SET_WIZARD_PROVIDER_OBJECT',
  SET_USER_DATA: 'CONTEXT_SET_USER_DATA',
  SET_I18N_MESSAGES: 'CONTEXT_SET_I18N_MESSAGES',
  TOGGLE_REMEMBER_DEVICE: 'CONTEXT_TOGGLE_REMEMBER_DEVICE',
  TOGGLE_STORE_DATA: 'CONTEXT_TOGGLE_STORE_DATA',
  SET_EDIT_USER: 'CONTEXT_SET_EDIT_USER',
  SET_EDIT_USER_ERRORS: 'CONTEXT_SET_EDIT_USER_ERRORS',
  SET_EDIT_USER_DATA: 'CONTEXT_SET_EDIT_USER_DATA',
  RESET_EDIT_USER_DATA: 'CONTEXT_RESET_EDIT_USER_DATA',
  SET_SHIPPING_DATA: 'CONTEXT_SET_SHIPPING_DATA',
  SET_EDIT_SHIPPING: 'CONTEXT_SET_EDIT_SHIPPING',
  SET_EDIT_SHIPPING_DATA: 'CONTEXT_SET_EDIT_SHIPPING_DATA',
  RESET_SHIPPING_DATA: 'CONTEXT_RESET_SHIPPING_DATA',
  RESET_IDENTIFIED_USER: 'CONTEXT_RESET_IDENTIFIED_USER',
  SET_INIT_IS_LOADING: 'CONTEXT_SET_INIT_IS_LOADING',
  SET_IS_LOADING: 'CONTEXT_SET_IS_LOADING'
}

export const THEME_TYPES = {
  SET_THEME: 'THEME_SET_THEME'
}
